const mimetypes = (state = [], action) => {
    switch (action.type) {
      case 'ADD_MIMETYPES':
        return action.mimetypes
      default:
        return state
    }
  }
  
  export default mimetypes